// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__dY6uS","titleH1":"Title_title-h1__fcJSQ","titleH2":"Title_title-h2__0cUPP","titleH3":"Title_title-h3__QMFfE"};